import { IItemProps } from '@aytm/app/swidget/base/questions/Ecommerce/types.ts'
import style from './style.module.scss'
import eStyles from '../ecommerce.module.scss'
import React, { useState } from 'react'
import { formatPriceWithLocale } from '../../functions.ts'
import { Button } from 'primereact/button'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale.ts'
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown'
import Gallery from '@aytm/app/swidget/base/questions/Ecommerce/Gallery.tsx'
import { layoutIsCompact } from '@aytm/app/swidget/base/lib/layout.ts'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import useSession from '@aytm/app/swidget/base/session/useSession.ts'

const Item = ({ schema, questionSchema, onClose, onAddToCart, qty, totals }: IItemProps) => {
  const { t, languageTag } = useSurveyLocale()
  const viewport = useViewport()
  const session = useSession()
  const [ddValue, setddValue] = useState(1)
  const findability =
    'find' == questionSchema.mode_type || (1 == questionSchema.max_cart_size && !questionSchema.shopping_cart)

  const maxQty = findability ? null : questionSchema.max_qty_per_product
  const maxCartSize = findability ? null : questionSchema.max_cart_size
  const maxMoney = findability ? null : questionSchema.max_money_spent
  const itemPrice = schema.discounted_price || schema.price
  const options = [...Array(100).keys()]
    .filter(
      v =>
        (!maxQty || v + 1 <= maxQty - qty) &&
        (!maxCartSize || v + 1 + totals[0] <= maxCartSize) &&
        (!maxMoney || (v + 1) * itemPrice + totals[1] <= maxMoney)
    )
    .map(i => {
      return { id: i + 1, label: (i + 1).toString(), value: i + 1 }
    })

  const dropdownChange = (v: DropdownChangeParams) => {
    setddValue(v.value as number)
  }

  return (
    <div data-testid="SW-SH-Popup" className={style.ecommerceItem}>
      <div className={style.photo}>
        <Gallery
          schema={schema}
          emulatedMobile={viewport.emulationMobileFrame || layoutIsCompact(session.props.layout)}
        />
      </div>
      <div className={style.info}>
        <div
          className={style.header}
          data-testid="SW-SH-Item-Header"
          dangerouslySetInnerHTML={{ __html: schema.text }}
        />
        <div
          className={style.text}
          data-testid="SW-SH-Item-Text"
          dangerouslySetInnerHTML={{ __html: schema.description }}
        />
        {!questionSchema.hide_price && (
          <>
            <div
              className={style.price}
              data-testid="SW-SH-Item-Price"
              dangerouslySetInnerHTML={{
                __html: schema.discounted_price
                  ? formatPriceWithLocale(schema.discounted_price, questionSchema.price_mask, languageTag)
                  : formatPriceWithLocale(schema.price, questionSchema.price_mask, languageTag)
              }}
            />
            {schema.units && <div className={eStyles.units}> {schema.units} </div>}
          </>
        )}

        <div className={`${eStyles.buttons} ${style.buttons}`} data-testid="SW-SH-Item-Buttons">
          <Dropdown
            options={options}
            confirmKeyboardSelect={true}
            onChange={dropdownChange}
            value={ddValue}
            disabled={!options.length || findability}
            placeholder="1"
          />
          <Button
            label={t('questions', 'ec', 'addToCart')}
            className={`${style.button}`}
            onClick={() => onAddToCart(ddValue)}
            data-testid="SW-SH-Item-AddButton"
            disabled={!options.length}
          />
        </div>
      </div>

      <div className={style.close} data-testid="SW-SH-Popup-Close" onClick={onClose}>
        <i className="icon-aytmfd-close" />
      </div>
    </div>
  )
}

export default Item
